import axios from "axios";
import React, { FC, useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../workers/WorkerCategories.css"
import deleteIcon from "../../../assets/img/small-logos/delete _icon.svg";
import Swal from "sweetalert2";
import "../userInfo/Users.css";
import LoadingGif from "src/components/layout/Loader";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { IMembershipPlans } from "src/helper/interfaces";
import Cookies from "js-cookie";
import editIcon from "../../../assets/img/small-logos/edit_icon.svg"
import crossIcon from "../../../assets/img/icons/cross-svgrepo-com.svg"
import plusIcon from "../../../assets/img/icons/plus-svgrepo-com.svg"
import minusIcon from "../../../assets/img/icons/minus-svgrepo-com.svg"


type InputValues = {
   [key: string]: string;
};

const getAllMembershipPlans = async (token: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/membership-plans`, {
      headers: {
         "x-access-token": token
      }

   })
};

const MembershipPlans = () => {

   const [plans, setPlans] = useState<IMembershipPlans[]>([])
   const initialValues: IMembershipPlans = {
      _id: "",
      plan_for: "",
      amount: "",
      membership_duration: "",
      membership_heading: "",
      membership_description: []
   };
   const [count, setCount] = useState(1);
   const [formInput, setFormInputs] = useState()
   const [descriptionArray, setDescriptionArray] = useState<string[]>([]);
   const [selectedPlan, setSelectedPlan] = useState(initialValues);
   const [show, setShow] = useState(false);
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state.loading.value);
   const Token = Cookies.get("token");
   const [iconFile, setIconFile] = useState<File | null>(null);

   const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      // console.log(formInput);
      event.preventDefault();

      // console.log(inputs);
      if (!Token) return;
      // formData.append('plan_for', selectedPlan?.plan_for ?? "");
      let desArray: any[] = [];
      Object.values(descriptionArray).map((data, key) => {
         desArray.push(data);
      })
      const data = {
         amount: selectedPlan?.amount ?? "",
         // duration: selectedPlan?.membership_duration,
         // heading: selectedPlan?.membership_heading ?? "",
         description: desArray ?? selectedPlan?.membership_description
      }

      // console.log(data)
      postData(data);
      dispatch(startLoading())

   }

   const postData = async (data: any) => {
      try {

         await axios.put(`${AppConfig.DEV_SERVER}/membership-plan/${selectedPlan?._id}`, data, {
            headers: {

               'content-type': 'application/json',
               "X-Access-Token": Token
            },

         }).then((res) => {
            // console.log("res: ", res?.data)
            if (res?.data?.status_code === 200) {
               setTimeout(() => {
                  dispatch(stopLoading());

                  // setModalShow(false);
                  setShow(false);
                  Swal.fire({
                     position: "center",
                     icon: "success",
                     text: res?.data?.msg,
                     title: "Updated Membership Plan.",
                     showConfirmButton: false,
                     timer: 2500
                  }).then(() => {
                     getAllMembershipPlans(Token as string)
                        .then((res) => {
                           if (res?.data?.status_code === 200) {
                              const data = res?.data?.data;
                              setPlans(data?.data);
                           }
                           else {
                              Swal.fire({
                                 icon: "error",
                                 title: "Something went wrong!",
                                 text: `${res?.data?.msg}`,

                              });
                           }
                        })
                        .catch((err: any) => {
                           console.log(err);
                        })
                  })
               }, 1500)

            }
            else {
               setShow(false);
               dispatch(stopLoading());
               Swal.fire({
                  position: "center",
                  icon: "error",
                  title: `${res?.data?.msg}`,
                  showConfirmButton: false,
                  timer: 2000
               }).then(() => {
                  setSelectedPlan(initialValues);

               })
            }
         })

         // console.log('Response data:', response.data);
      } catch (error: any) {
         console.error('Error making POST request:', error.response ? error.response.data : error.message);
      }
   };

   const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const { name, value } = event.target;
      // console.log(name, value);
      setSelectedPlan({ ...selectedPlan, [name]: value });
   }


   const clickOnEdit = (id: string) => {
      const servicToEdit = plans?.find((plan: IMembershipPlans) => plan._id === id);
      if (servicToEdit !== undefined) {
         // console.log(servicToEdit);
         setSelectedPlan({
            _id: servicToEdit?._id,
            plan_for: servicToEdit?.plan_for,
            amount: servicToEdit?.amount,
            membership_duration: servicToEdit?.membership_duration,
            membership_heading: servicToEdit?.membership_heading,
            membership_description: servicToEdit?.membership_description
         });
         setCount(servicToEdit?.membership_description?.length);
         setDescriptionArray(servicToEdit?.membership_description)
      }
      setShow(true)
   }

   useEffect(() => {
      if (Token) {
         dispatch(startLoading());
         getAllMembershipPlans(Token)
            .then((res) => {
               if (res?.data?.status_code === 200) {
                  const data = res?.data?.data;
                  setPlans(data?.data);
               }
               else {
                  Swal.fire({
                     icon: "error",
                     title: "Something went wrong!",
                     text: `${res?.data?.msg}`,

                  });
               }
            })
            .catch((err: any) => {
               console.log(err);
            })
            .finally(() => {
               dispatch(stopLoading());
            });
      }
   }, [Token]);

   // useEffect(() => {
   //    const descriptionCount = Array.from({ length: count }, (_, i) => i + 1);
   //    setDescriptionArray(descriptionCount);
   //    console.log("descriptionArray: ", descriptionCount);
   // }, [count])


   const handleInputChange = (index: number, value: string) => {

      const updatedArray = [...descriptionArray];
      updatedArray[index] = value;
      setDescriptionArray(updatedArray);
   };

   return (
      <MainLayout >


         {show && (
            <div className="modal fade show d-block" role="dialog">
               <div className="modal-dialog">
                  <div className="modal-content">
                     <div className="modal-header">
                        <button
                           type="button"
                           className="close"
                           onClick={() => {
                              setShow(false);
                              setCount(1);
                              setDescriptionArray([])
                           }}
                           style={{ outline: "none", border: "0px" }}
                        >
                           <img src={crossIcon} alt="hide-icon" style={{ height: "20px", width: "20px" }} />
                        </button >
                        <h4 className="modal-title">Update Membership</h4>
                     </div>
                     <div className="modal-body gap-2">
                        <div className="d-flex flex-column pb-2">
                           <label htmlFor="amount" className="text-start pb-2">
                              Amount
                           </label>
                           <input
                              type="number"
                              name="amount"
                              value={selectedPlan?.amount}
                              id="amount"
                              className="form-control"
                              onChange={handleChange}
                           />
                        </div>
                        <div className="d-flex flex-column">
                           <label htmlFor="description" className="d-flex justify-content-between pb-2">

                              Description
                              <button
                                 className="d-flex justify-content-center align-items-center"
                                 style={{ border: 0 }}
                                 onClick={() => setCount(count + 1)}
                              >
                                 <div className="d-flex justify-content-center align-items-center">
                                    <img src={plusIcon} alt="add-icon" style={{ width: "20px", height: "20px" }} />
                                 </div>

                              </button>
                           </label>
                           {
                              loading ? <LoadingGif /> : ""
                           }
                           {
                              Array.from({ length: count }, (_, i) => i + 1)?.map((index) => (
                                 <div className="d-flex gap-3 mb-2" key={index - 1}>
                                    <input
                                       type="text"
                                       name="description"
                                       id={`description-${index - 1}`}
                                       value={descriptionArray[index - 1] || ""}
                                       className="form-control w-90"
                                       onChange={(event) => handleInputChange(index - 1, event.target.value)}
                                    />
                                    <button
                                       className="justify-content-center align-items-center"
                                       style={{ outline: "none", border: "0px", display: count === 1 ? "none" : "flex" }}
                                       onClick={() => {
                                          if (count > 1) {
                                             // Remove the item from descriptionArray
                                             setDescriptionArray((prev) => prev.filter((_, idx) => idx !== index - 1));
                                             // Decrement the count
                                             setCount(count - 1);
                                          }
                                       }}
                                    >
                                       <img
                                          src={minusIcon}
                                          alt="remove-icon"
                                          style={{ width: "20px", height: "20px" }}
                                       />
                                    </button>
                                 </div>
                              ))
                           }

                        </div>
                     </div>

                     <div className="modal-footer">
                        <button
                           type="button"
                           className="btn btn-primary "
                           onClick={(event: any) => handleFormSubmit(event)}
                        >
                           Update
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         )}
         {/* </form> */}


         <div className="mt-3 mb-3">
            <div className="card category-main me-2 p-md-4" >
               {
                  loading ? <LoadingGif /> : ""
               }

               <div className="table-responsive">
                  <table className="table table-striped card-body">
                     <thead>
                        <tr className="category-tr">
                           {/* <th scope="col" className="text-start ps-4">Icon</th> */}
                           <th scope="col" className="text-start ps-4">Plan For</th>
                           <th scope="col" className="text-start ps-4">Amout</th>
                           <th scope="col" className="text-start ps-4">Duration</th>
                           <th scope="col" className="text-start ps-4">Heading</th>
                           <th scope="col" className="text-start ps-4">Description</th>
                           <th scope="col" className="col-lg-2 ps-4 ">Action</th>
                        </tr>
                     </thead>
                     <tbody>
                        {
                           plans && plans?.map((data: IMembershipPlans) => {

                              return (
                                 <tr key={data?._id}>

                                    <td className="text-start align-content-center ps-4">
                                       <span className="">
                                          {data?.plan_for}
                                       </span>

                                    </td>
                                    <td className="icon-td align-content-center text-start ps-4">
                                       {data?.amount}
                                    </td>
                                    <td className="icon-td align-content-center text-start ps-4">
                                       {data?.membership_duration}
                                    </td>
                                    <td className="icon-td align-content-center text-start ps-4">
                                       {data?.membership_heading}
                                    </td>
                                    <td className="icon-td align-content-center text-start ps-4">
                                       <ul>
                                          {data?.membership_description?.map((item, id) => {
                                             return (
                                                <li key={id}>{item}</li>
                                             );
                                          })}
                                       </ul>
                                    </td>

                                    <td className="align-content-center ">
                                       <div className="d-flex justify-content-center gap-3">
                                          <button className="btn btn-sm edit_btn" onClick={() => clickOnEdit(data?._id)} style={{ marginBottom: "1px" }}>
                                             <img src={editIcon} />
                                          </button>

                                       </div>

                                    </td>
                                 </tr>
                              )
                           }
                           )
                        }

                     </tbody>
                  </table>

               </div>




            </div>

         </div>

      </MainLayout>
   )

};



export default MembershipPlans;